import { takeEvery, call } from 'redux-saga/effects';
import { mkQcsSyncResourceConfig } from 'data/qcsSyncResourceTypes';
import { qcsSyncUpdateResources, getQcsSyncResources, qcsSyncUpdateResource }
  from 'data/qcsSyncResourceSagaHelpers';
import * as actions from './budgetsActions';
import { getLastSyncDate } from './budgetsSelectors';
import { mkBudgetSchedule, mkBudgetRecord } from './budgetsTypes';

const mkResourceConfig = (props) => mkQcsSyncResourceConfig({
  resourceName: 'budgets',
  resourceBaseUrl: '/budgets',
  getLastSyncDate,
  // transformResponseToResources: ,
  // transformResourceToRequestData:,
  ...props,
});

export function* createBudgetsActionWatcher() {
  const config = mkResourceConfig({
    successAction: actions.createBudgetsSuccessAction,
    failureAction: actions.createBudgetsFailureAction,
  });
  yield takeEvery(actions.createBudgetsAction, qcsSyncUpdateResources, config);
}

export function* updateBudgetActionWatcher() {
  const config = mkResourceConfig({
    successAction: actions.updateBudgetSuccessAction,
    failureAction: actions.updateBudgetFailureAction,
  });
  yield takeEvery(actions.updateBudgetAction, qcsSyncUpdateResource, config);
}

function* deleteBudgets(config, data) {
  const newData = data;
  newData.payload = data.payload.map((item) => item.set('isDeleted', true));
  return yield call(qcsSyncUpdateResources, config, newData);
}

export function* deleteBudgetsActionWatcher() {
  const config = mkResourceConfig({
    successAction: actions.deleteBudgetsSuccessAction,
    failureAction: actions.deleteBudgetsFailureAction,
  });
  yield takeEvery(actions.deleteBudgetsAction, deleteBudgets, config);
}

export function* getBudgetsActionWatcher() {
  const config = mkResourceConfig({
    successAction: actions.getBudgetsSuccessAction,
    failureAction: actions.getBudgetsFailureAction,
    transformResponseToResources: (response: any) => response.data.resources.map((data) => mkBudgetRecord({
      ...data,
      schedule: mkBudgetSchedule(data.schedule),
    })),
  });
  yield takeEvery(actions.getBudgetsAction, getQcsSyncResources, config);
}

export default [getBudgetsActionWatcher, createBudgetsActionWatcher, updateBudgetActionWatcher, deleteBudgetsActionWatcher];
